<template>
  <div class="home">
   
   <Content></Content>
   <!-- <Content1></Content1> -->
   
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Content from '@/components/Content.vue'
import Content1 from '@/components/Content1.vue'

import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Header,
    Footer,
    Content,
    Content1

  }
}
</script>
<style  scoped>
.home{
  margin-top: 25px;
}
</style>
